import React from 'react';

import SolidIcon from '@material-ui/icons/Brightness1';
import { Button, Grid, ListItem, ListItemIcon, List, Typography, ListItemText, makeStyles } from '@material-ui/core';
import { AddAssetAction } from '../../../../entities/AddAssetAction';

const useStyles = makeStyles((theme) => ({
    toolbar: theme.mixins.toolbar,
    subtitle: {
        paddingTop: theme.spacing(1),
        textAlign: 'center',
        paddingBottom: 10,
        fontSize: 19
    },
    circleText: {
        padding: '21px',
        textAlign: 'center',
        fontWeight: 500,
        color: "white",
        fontSize: 30,
    },
    '@keyframes geniusPulse': {
        "0%": {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(52, 172, 224, 0.7)',
        },
        '70%': {
            transform: 'scale(1)',
            boxShadow: '0 0 0 10px rgba(52, 172, 224, 0)',
        },
        '100%': {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(52, 172, 224, 0)'
        }
    },
    '@keyframes analyzerPulse': {
        "0%": {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(21, 77, 88, 0.7)',
        },
        '70%': {
            transform: 'scale(1)',
            boxShadow: '0 0 0 10px rgba(21, 77, 88, 0)',
        },
        '100%': {
            transform: 'scale(0.95)',
            boxShadow: '0 0 0 0 rgba(21, 77, 88, 0)'
        }
    }
}));

interface Props {
    title:string;
    listText: string[];
    upgradeAction: AddAssetAction;
    upgradePath: string;
    color: string;
    displayNumber: number;
}

export function UnpaidDrawer(props:Props) {
    const { title,listText, upgradeAction, upgradePath, color, displayNumber} = props;
    const classes = useStyles();
    const upSellUrl = `https://www.sermonmaker.net/upgrade-now/?upgradePath=${upgradePath}&upgradeAction=${upgradeAction}`;

    const onUpsellOpen = () => {
        window.location.assign(upSellUrl);
    }

    const geniusTextBlock = <span>Discover <strong>{displayNumber}</strong> preaching ideas to make your sermon stronger, <a href={upSellUrl} style={{color: '#2196F3'}}>activate now to unlock</a></span>;
    const analyzerTextBlock = <span>Make your sermon even better with <strong>{displayNumber}</strong> preaching suggestion{displayNumber > 1 ? 's' : ''}, <a href={upSellUrl} style={{color: '#2196F3'}}>activate now to unlock</a></span>;
    
    return (
        <Grid container alignItems='center' alignContent='center' justifyContent='center'>
            <Typography className={classes.subtitle}>
                Activate {title}
            </Typography>
            <Typography variant="body1" style={{ textAlign: 'center' }}>
                {upgradePath === "Genius" ? geniusTextBlock : analyzerTextBlock}
            </Typography>
            <Grid container alignItems='center' alignContent='center' justifyContent='center'>
                <div style={{
                        borderRadius: '50%',
                        width: 90,
                        height: 90,
                        color: 'white',
                        backgroundColor: `${color}`,
                        margin: '25px 0',
                        animation: upgradePath === "Genius" ? 'geniusPulse 2s infinite' : 'analyzerPulse 2s infinite',
                        boxShadow: `0 0 0 ${color}` }} >
                    <Typography variant="h6" className={classes.circleText}>{displayNumber}</Typography>
                </div>
            </Grid>
            <Grid container alignItems='center' alignContent='center' justifyContent='center'>
                <List>
                    { listText.map( (li, index) => {
                        return (
                        <ListItem style={{ padding: '0px 5px' }} key={index}>
                        <ListItemIcon style={{ marginRight: 0}}>
                            <SolidIcon style={{ color:`${color}`, fontSize: 'small'}} />
                        </ListItemIcon>
                        <ListItemText>{li}</ListItemText>
                        </ListItem>
                        )}
                    )}
                </List>
            </Grid>
            <Grid container alignItems='center' alignContent='center' justifyContent='center'>
                <Button size='large' style={{ backgroundColor: `${color}`, color: 'white', margin: '30px 0px'}}
                onClick={() => onUpsellOpen()}>Activate Now</Button>   
            </Grid>
        </Grid>
    )
}